module.exports = __webpack_public_path__ + "img/qr_xiaoshimei.e4ddcfab.jpeg";